import { render, staticRenderFns } from "./_DetailsPassageInfirmerie.vue?vue&type=template&id=577ed06c&"
import script from "./_DetailsPassageInfirmerie.vue?vue&type=script&lang=ts&"
export * from "./_DetailsPassageInfirmerie.vue?vue&type=script&lang=ts&"
import style0 from "./_DetailsPassageInfirmerie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports